import React from 'react';

const CreateNoteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6665 6.79333H11.7398C10.1598 6.79333 8.87317 5.50666 8.87317 3.92666V1.99999C8.87317 1.63333 8.57317 1.33333 8.2065 1.33333H5.37984C3.3265 1.33333 1.6665 2.66666 1.6665 5.04666V10.9533C1.6665 13.3333 3.3265 14.6667 5.37984 14.6667H10.6198C12.6732 14.6667 14.3332 13.3333 14.3332 10.9533V7.45999C14.3332 7.09333 14.0332 6.79333 13.6665 6.79333Z"
      fill="#3F3F46"
    />
    <path
      d="M10.5333 1.47333C10.26 1.2 9.78662 1.38667 9.78662 1.76667V4.09333C9.78662 5.06667 10.6133 5.87333 11.62 5.87333C12.2533 5.88 13.1333 5.88 13.8866 5.88C14.2666 5.88 14.4666 5.43333 14.2 5.16667C13.24 4.2 11.52 2.46 10.5333 1.47333Z"
      fill="#3F3F46"
    />
  </svg>
);

export default CreateNoteIcon;
